var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 3.00005H4.1C2.83988 3.00005 2.20982 3.00005 1.72852 3.24528C1.30516 3.461 0.96095 3.80521 0.745235 4.22857C0.5 4.70987 0.5 5.33993 0.5 6.60005V12.9C0.5 14.1602 0.5 14.7902 0.745235 15.2715C0.96095 15.6949 1.30516 16.0391 1.72852 16.2548C2.20982 16.5 2.83988 16.5 4.1 16.5H10.4C11.6601 16.5 12.2902 16.5 12.7715 16.2548C13.1948 16.0391 13.539 15.6949 13.7548 15.2715C14 14.7902 14 14.1602 14 12.9V9.75005M4.99998 12H6.25589C6.62277 12 6.80622 12 6.97885 11.9586C7.1319 11.9219 7.27822 11.8613 7.41243 11.779C7.5638 11.6862 7.69352 11.5565 7.95294 11.2971L15.125 4.12505C15.7463 3.50373 15.7463 2.49637 15.125 1.87505C14.5037 1.25373 13.4963 1.25373 12.875 1.87505L5.70293 9.0471C5.4435 9.30653 5.31378 9.43625 5.22102 9.58762C5.13878 9.72183 5.07817 9.86815 5.04143 10.0212C4.99998 10.1938 4.99998 10.3773 4.99998 10.7442V12Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.8dd342721f8719f93295fc9efc624649.svg";
export { ForwardRef as ReactComponent };